import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { Button } from '@monorepo/shared/componentsV2/Button';
import { useOpenClose } from '@monorepo/shared/hooks/useOpenClose';
import React from 'react';
import styled from 'styled-components';
import { useFormTemplateContext } from '../EditFormTemplatePage/FormTemplateContext';
import { AddFieldModal } from './AddFieldModal/AddFieldModal';

const StyledAddButton = styled(Button)`
  margin-bottom: 1rem;
`;

type AddFormTemplateFieldProps = {
  isAddingDisabled: boolean;
  isInDuplicableSection: boolean;
};

export function AddFormTemplateField({
  isAddingDisabled,
  isInDuplicableSection,
}: AddFormTemplateFieldProps) {
  const [isOpen, openModal, closeModal] = useOpenClose();

  const {
    formTemplateHelpers: { addField },
  } = useFormTemplateContext();

  return (
    <>
      <StyledAddButton
        color="primary"
        onClick={openModal}
        disabled={isAddingDisabled}
      >
        <AddCircleOutlineIcon />
        Add new field
      </StyledAddButton>
      <AddFieldModal
        isOpen={isOpen}
        onClose={closeModal}
        onSubmit={addField}
        isInDuplicableSection={isInDuplicableSection}
      />
    </>
  );
}
